import Loader from "./Loader"

const FullPageLoader = () => (
  <div className="fixed inset-0 flex flex-col items-center justify-center gap-6 bg-primary text-white">
    <img alt="logo" className="h-20" src="/logo.png" />
    <Loader className="h-6 w-6" />
  </div>
)

export default FullPageLoader
